__turbopack_context__.v({
  "cost-with-icon": "index-module-scss-module__5NRHIW__cost-with-icon",
  "icon-wrapper": "index-module-scss-module__5NRHIW__icon-wrapper",
  "leaf-icon": "index-module-scss-module__5NRHIW__leaf-icon",
  "name-and-price": "index-module-scss-module__5NRHIW__name-and-price",
  "shipping-cost": "index-module-scss-module__5NRHIW__shipping-cost",
  "shipping-cost-wrapper": "index-module-scss-module__5NRHIW__shipping-cost-wrapper",
  "shipping-icons-container": "index-module-scss-module__5NRHIW__shipping-icons-container",
  "shipping-option-separator": "index-module-scss-module__5NRHIW__shipping-option-separator",
  "shipping-options": "index-module-scss-module__5NRHIW__shipping-options",
  "shipping-text": "index-module-scss-module__5NRHIW__shipping-text",
  "shipping-type": "index-module-scss-module__5NRHIW__shipping-type",
});
